<div [ngClass]="{ 'full-screen': fullScreen }" class="modal solid" id="IdentityVisualizer">
  <div class="tp-data-header">
    <div class="modaltitle">Identity Service Path</div>
    <div (click)="hide()" class="buttonBall icon-close" id="EscZEndpointClose"></div>
    <div (click)="toggleModalSize()" class="buttonBall resize" id="ResizeModalButton"></div>
  </div>
  <div [ngClass]="isDarkMode==true?'darkMode':'lightMode'" class="identity-topology-container">
    <div style="width: 100%; height: 80px; float: left">
      <div class="ep-topology-filter-container listBox row">
        <input
          (keyup)="filterSearchArray()"
          [(ngModel)]="selectedService"
          [matAutocomplete]="auto"
          class="topology-filter-input"
          id="filterText"
          matInput
          placeholder="Type to search identity accessible services."
          />

        @if (filterText) {
          <div
            (click)="clearSearchFilter()"
            class="clear-svc-icon icon-close"
            id="ClearSearchFilter"
          ></div>
        }
        <div [hidden]="!noSearchResults" class="no-results-warning">No Results Found</div>
        <mat-autocomplete #auto="matAutocomplete" (optionSelected)="autocompleteSearch($event)">
          @for (option of autocompleteOptions; track option) {
            <mat-option [value]="option.name">
              {{ option.name }}
            </mat-option>
          }
        </mat-autocomplete>
      </div>
    </div>

    <div class="topotip" id="epTooltip"></div>

    <svg style='pointer-events:all' height="1000" id="IdentityTopology" width="1400">
    </svg>
    @if (isLoading) {
      <lib-loading-indicator [isLoading]="isLoading"></lib-loading-indicator>
    }

    <div class="topology-legend">
      <div class="legend-section">
        <div class="legend-section-title">Nodes</div>
        <div class="legend-item">
          <div class="legend-icon-col"><img class="legend-node-icon" src="/assets/images/visualizer/host.png" /></div>
          <div class="legend-text">Identity</div>
        </div>
        <div class="legend-item">
          <div class="legend-icon-col"><img class="legend-node-icon" src="/assets/images/visualizer/Routers.png" /></div>
          <div class="legend-text">Edge Router</div>
        </div>
        <div class="legend-item">
          <div class="legend-icon-col"><img class="legend-node-icon" src="/assets/images/visualizer/service.png" /></div>
          <div class="legend-text">Service</div>
        </div>
      </div>
      <div class="legend-section">
        <div class="legend-section-title">Status</div>
        <div class="legend-item">
          <div class="legend-icon-col"><div class="legend-circle registered_in_use"></div></div>
          <div class="legend-text">Online</div>
        </div>
        <div class="legend-item">
          <div class="legend-icon-col"><div class="legend-circle unregistered"></div></div>
          <div class="legend-text">Offline</div>
        </div>
        <div class="legend-item">
          <div class="legend-icon-col"><div class="legend-circle errored"></div></div>
          <div class="legend-text">Error</div>
        </div>
      </div>
      @if (fabricApiAvailable) {
        <div class="legend-section">
          <div class="legend-section-title">Path</div>
          <div class="legend-item">
            <div class="legend-icon-col"><div class="legend-line active-circuit"></div></div>
            <div class="legend-text">Active Circuit</div>
          </div>
          <div class="legend-item">
            <div class="legend-icon-col"><div class="legend-line available"></div></div>
            <div class="legend-text">Available</div>
          </div>
          <div class="legend-item">
            <div class="legend-icon-col"><div class="legend-icon misconfigured"></div></div>
            <div class="legend-text">Broken</div>
          </div>
        </div>
      }
    </div>

  </div>
</div>
